import * as React from 'react';
import { LiveEvent as TLiveEvent } from '../../../EventsStore/Types';
import { NotTranslated } from '../../../Translations';
import * as style from '../style.module.css';

interface Props {
  event: TLiveEvent;
}

const LiveEvent: React.FC<Props> = ({ event: { title } }) => (
  <a href="#" className={style.liveEvent} data-test-live-event={title}>
    <span className={style.eventLabel} data-test-event-title={title}>
      <NotTranslated text={title} />
    </span>
  </a>
);

export default LiveEvent;
